import React from 'react';
import {graphql} from 'react-relay';
import {ForecastQueryRenderer} from '../../ForecastQueryRenderer';
import {hasFeatureFlag} from '../../forecast-app/shared/util/FeatureUtil';
import type {BillFromRef} from '../../forecast-app/admin-tab/finance-page/InvoiceIntegrationsUtils';
import type {ImportClientsBillFromsLoaderQuery$data} from './__generated__/ImportClientsBillFromsLoaderQuery.graphql';

const importClientsBillFromsLoaderQuery = graphql`
	query ImportClientsBillFromsLoaderQuery {
		viewer {
			actualPersonId
			component(name: "import_clients_bill_froms")
			company {
				id
				billFroms {
					id
					integration
					externalId
				}
			}
		}
	}
`;

type Props = {
	render: (billFroms: readonly BillFromRef[] | null) => React.ReactNode;
};

/**
 * The Xero, QuickBooks and e-conomic import modals are class components opened with only a
 * companyId, so they have no Relay data. This loads the Bill Froms they need to give each imported
 * client its Bill To. With invoicing_pathways off nothing is fetched and the modal gets null, which
 * keeps the import exactly as it was.
 */
const ImportClientsBillFromsLoader = ({render}: Props) => {
	if (!hasFeatureFlag('invoicing_pathways')) {
		return <>{render(null)}</>;
	}
	return (
		<ForecastQueryRenderer
			key="query-render-import-clients-bill-froms"
			query={importClientsBillFromsLoaderQuery}
			modal={true}
			render={(relayProps: ImportClientsBillFromsLoaderQuery$data) => {
				const billFroms = (relayProps?.viewer?.company?.billFroms || []).filter(
					(billFrom): billFrom is BillFromRef => !!billFrom
				);
				return render(billFroms);
			}}
		/>
	);
};

export default ImportClientsBillFromsLoader;
